import { render } from "./MarketplaceFilterBody.vue?vue&type=template&id=487a8ea3"
import script from "./MarketplaceFilterBody.vue?vue&type=script&lang=js"
export * from "./MarketplaceFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__